/**
 * Reads/writes a value on a Record using a key that TypeScript already
 * guarantees is a member of that Record's key type. Centralizes the
 * eslint-disable for security/detect-object-injection so call sites stay
 * clean instead of scattering per-line disables.
 */
export function getRecordValue<K extends PropertyKey, V>(
  record: Record<K, V>,
  key: K
): V {
  // eslint-disable-next-line security/detect-object-injection -- key is statically typed as keyof record
  return record[key];
}

export function setRecordValue<K extends PropertyKey, V>(
  record: Record<K, V>,
  key: K,
  value: V
): void {
  // eslint-disable-next-line security/detect-object-injection -- key is statically typed as keyof record
  record[key] = value;
}

/**
 * Array equivalents of getRecordValue/setRecordValue. Arrays don't
 * structurally satisfy Record<number, T> for TypeScript's inference, so
 * they get their own thin wrappers.
 */
export function getArrayValue<T>(array: readonly T[], index: number): T {
  // eslint-disable-next-line security/detect-object-injection -- index is a validated array index
  return array[index];
}

export function setArrayValue<T>(array: T[], index: number, value: T): void {
  // eslint-disable-next-line security/detect-object-injection -- index is a validated array index
  array[index] = value;
}
